import React from 'react'
import { useTranslation } from 'react-i18next'
import Loader from 'components/common/Loader'
import ImagePreview from 'components/ImagePreview'
import c from './ProcessingStage.module.scss'

interface ProcessingStageProps {
  imageUrl: string
}

function ProcessingStage({ imageUrl }: ProcessingStageProps) {
  const { t } = useTranslation()

  return (
    <>
      <ImagePreview imageUrl={imageUrl} />
      <div className="bottom">
        <div className={c.loader}>
          <Loader />
          <p className={c.loaderText}>
            {t('stages.enhancement.processing.loaderText')}
          </p>
        </div>
        <div className={c.banner}>
          <p className={c.bannerText}>
            {t('stages.enhancement.processing.bannerText')}
          </p>
        </div>
      </div>
    </>
  )
}

export default ProcessingStage
